import { dew as _parseAccountDew } from "../../accounts/utils/parseAccount.js";
import { dew as _accountDew } from "../../errors/account.js";
import { dew as _toHexDew } from "../../utils/encoding/toHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.signMessage = void 0;
  const parseAccount_js_1 = _parseAccountDew();
  const account_js_1 = _accountDew();
  const toHex_js_1 = _toHexDew();
  async function signMessage(client, {
    account: account_ = client.account,
    message
  }) {
    if (!account_) throw new account_js_1.AccountNotFoundError({
      docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, parseAccount_js_1.parseAccount)(account_);
    if (account.type === "local") return account.signMessage({
      message
    });
    const message_ = (() => {
      if (typeof message === "string") return (0, toHex_js_1.stringToHex)(message);
      if (message.raw instanceof Uint8Array) return (0, toHex_js_1.toHex)(message.raw);
      return message.raw;
    })();
    return client.request({
      method: "personal_sign",
      params: [message_, account.address]
    });
  }
  exports.signMessage = signMessage;
  //# sourceMappingURL=signMessage.js.map
  return exports;
}